'use client';

import { c as _c } from "react/compiler-runtime";
import { Heading } from '@navikt/ds-react';
import { store } from './store/store';
import bannerStyles from '@/app/_components/Banner.module.css';
import { Virksomhetsvelger } from '@/app/_components/virksomhetsvelger/Virksomhetsvelger/Virksomhetsvelger';
import { AltinnOrganisasjon } from '@/types/api';
export const Banner = t0 => {
  const $ = _c(11);
  const {
    organisasjoner: t1,
    heading
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const organisasjoner = t2;
  const actions = store.useActions();
  const valgtOrg = store.useReducerState().bruker.valgtOrg;
  let t3;
  if ($[2] !== heading) {
    t3 = <Heading size="large" level="1">{heading}</Heading>;
    $[2] = heading;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== actions || $[5] !== organisasjoner || $[6] !== valgtOrg) {
    t4 = organisasjoner.length > 0 && valgtOrg && <Virksomhetsvelger organisasjoner={organisasjoner} friKomponent={true} kunHovedenheter={true} initValgtOrgnr={valgtOrg?.orgnr} onChange={org => {
      if (valgtOrg?.orgnr === org.orgnr) {
        return;
      }
      actions.SET_VALGT_ORG(organisasjoner.find(o => o.orgnr === org.orgnr));
    }} />;
    $[4] = actions;
    $[5] = organisasjoner;
    $[6] = valgtOrg;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <header><div className={bannerStyles.bannerContainer}><div className={bannerStyles.banner}><div className={bannerStyles.innerBanner}>{t3}{t4}</div></div></div></header>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};